import { ExternalLink } from "lucide-react";

// Lightweight, key-free map pin using the OpenStreetMap embed (single marker).
export function LocationMap({ lat, lng, label, height = 150, delta = 0.006, className = "" }) {
  if (lat == null || lng == null) return null;
  const bbox = [lng - delta, lat - delta, lng + delta, lat + delta]
    .map((n) => n.toFixed(6))
    .join("%2C");
  const src = `https://www.openstreetmap.org/export/embed.html?bbox=${bbox}&layer=mapnik&marker=${lat}%2C${lng}`;
  const osm = `https://www.openstreetmap.org/?mlat=${lat}&mlon=${lng}#map=16/${lat}/${lng}`;
  return (
    <div className={className} data-testid="location-map">
      <div className="overflow-hidden rounded-xl border border-white/10">
        <iframe
          title={label || "map"}
          src={src}
          width="100%"
          height={height}
          loading="lazy"
          style={{ border: 0, display: "block" }}
        />
      </div>
      <a
        href={osm}
        target="_blank"
        rel="noreferrer"
        data-testid="location-map-link"
        className="mt-1.5 inline-flex items-center gap-1 text-[11px] font-medium text-blue-500 hover:underline"
      >
        Open in maps <ExternalLink className="h-3 w-3" />
      </a>
    </div>
  );
}
